import { render, staticRenderFns } from "./SchoolsDropdown.vue?vue&type=template&id=30def586&scoped=true&"
import script from "./SchoolsDropdown.vue?vue&type=script&lang=js&"
export * from "./SchoolsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30def586",
  null
  
)

export default component.exports